export default __webpack_public_path__ + "static/media/thumbnail_theater_2023.f58d2b20.jpg";